import $ from 'jquery';
import CurrentBreakpoint from 'components/utils/CurrentBreakpoint';
import EventDispatcher from 'components/csrFactoryMap/utils/EventDispatcher';
import EventTypes from 'components/EventTypes';
  const $window = window.jq;
  const $document = document.jq;
  let viewportData = {
    breakpoint: null,
    width: 0,
    height: 0,
  };

  class ResizeManager extends EventDispatcher {
    constructor() {
      super();
      this.initialize();
    }

    initialize() {
      this.setupEventListeners();
      this.initialState();
    }

    // Public functions
    getViewportData() {
      return viewportData;
    }

    // Private functions
    setupEventListeners() {
      $window.on('resizeEnd', (e) => this.onResizeEnd(e));
      $document.on(EventTypes.BREAKPOINT_CHANGED, (e, data) => this.onBreakpointChange(e, data));
    }

    initialState() {
      this.updateData(
        {
          breakpoint: CurrentBreakpoint.getCurrentBreakpoint(),
          width: window.innerWidth,
          height: window.innerHeight,
        },
        true
      );
    }

    updateData(obj, silent) {
      viewportData = Object.assign(viewportData, obj);
      if (!silent) {
        this.trigger('resize:change');
      }
    }

    // Listeners
    onBreakpointChange(e, data) {
      if (viewportData.breakpoint !== data.breakpoint) {
        this.updateData({ breakpoint: data.breakpoint });
        this.trigger('resize:change:breakpoint');
      }
    }

    onResizeEnd(e) {
      const w = window.innerWidth;
      const h = window.innerHeight;
      if (viewportData.width !== w || viewportData.height !== h) {
        this.updateData({ width: w, height: h });
        this.trigger('resize:change:size');
      }
    }
  }

  export default new ResizeManager();

